
/**
 * `kioskApiPages`.
 */

const kioskApiPages = {
  kioskHome: 'kiosk-homepage'
};

/**
 * Export `pt` api page routes.
 */

export const pt = {
  ...kioskApiPages,
  aboutUs: 'sobre-nos',
  aboutUsSgiPolicy: 'politica-do-sistema-de-gestao-integrado',
  careers: 'recrutamento',
  certificates: 'certificados',
  collection: null,
  collections: 'colecoes',
  contacts: 'contactos',
  cookiesPolicy: 'politica-de-cookies',
  downloads: 'downloads',
  environment: 'ambiente',
  faq: null,
  faqs: 'perguntas-frequentes',
  fundedProjects: 'projetos-financiados',
  highlights: 'destaques',
  history: 'historia',
  home: 'homepage',
  innovation: 'inovacao',
  inspiration: 'inspiracao',
  inspirationDetails: 'inspiracao-detalhe',
  lightXl: 'light-xl',
  media: 'media',
  portfolio: 'portfolio',
  portfolioDetails: 'portfolio-detalhe',
  privacyPolicy: 'politica-de-privacidade',
  productContact: 'produto-contacte-nos',
  productDetails: null,
  recommend: 'recomendador',
  recommendResults: null,
  reportingChannel: 'canal-de-denuncias',
  socialResponsability: 'responsabilidade-social',
  storytiling: 'storytiling',
  storytilingDetails: 'storytiling-detalhe',
  tech20mm: 'tech-20mm',
  termsConditions: 'termos-e-condicoes',
  toolsBimObjects: 'objetos-bim',
  toolsProductComparator: 'comparador-de-produtos',
  whereToBuy: 'onde-comprar',
  whereToBuyResults: 'onde-comprar-resultados'
};
